<template lang="pug">
  .postEditor_container
    b-loading(v-model="isLoading" :is-full-page="false")
    .postEditor_content
      .postEditor_columns
        .postEditor_column._w70
          .postEditor_input._title
            .postEditor_head
              label._label(for="title") 記事タイトル
                span._required *
            b-field
              b-input#title(
                v-model="post.title"
                type="text"
                autocomplete="off")
        .postEditor_column._w30
          .postEditor_toggle
            .postEditor_head
              ._label 外部リンク
                span._required *
            b-switch(
              v-model="post.link_flag"
              type="is-info"
              size="is-medium") {{isLinkMessage}}
      template(v-if="!post.link_flag")
        .postEditor_column
          .postEditor_input._description
            .postEditor_head
              label._label(for="description") 概要
                span._required *
              b-tooltip.tooltip(
                position="is-right"
                size="is-medium"
                type="is-light")
                button.ui-tooltip(type="button")
                  b-icon.is-opacity(icon="question-circle" size="is-small")
                template(v-slot:content)
                  strong 目安：50文字〜150文字程度<br>
                  | 記事一覧のリード文 として表示されます。<br>
                  | meta description にも使用されます。
            b-input#description(
              type="textarea"
              v-model="post.description"
              autocomplete="off"
              rows="2"
              maxlength=150
              has-counter)
        .postEditor_body
          .postEditor_head
            ._label 内容
              span._required *
            .postEditor_images
              b-button(
                type="is-info"
                size="is-medium"
                outlined
                icon-left="image-v"
                @click="switchMediaModal('imageInArticle')") 画像の挿入
          froala(
            id="froala-editor"
            :config="config"
            v-model="post.content"
            :onManualControllerReady="initialize")
      template(v-else)
        .postEditor_column
            .postEditor_input
              .postEditor_head
                label._label(for="externalUrl") リンク先
                  span._required *
              b-input#externalUrl(
                v-model="post.link"
                type="url")
              b-button.mt-4(
                type="is-info"
                size="is-medium"
                outlined
                :disabled="externalLinkInput.isDisabled"
                @click="openLinkPage()") リンク先を確認する
    .postEditor_panel
      .postEditor_panel_head
        .postEditor_meta
          b-switch.release_flag(
            v-model="post.release_flag"
            type="is-info"
            size="is-medium") {{isPublishMessage}}
          b-button.mr-1(
            v-if="!post.link_flag"
            type="is-info"
            outlined
            size="is-medium"
            :loading="postSaving"
            @click="previewArticle()") プレビュー
          b-button(
            v-if="$route.params.id"
            type="is-info"
            size="is-medium"
            :loading="postSaving"
            @click="updateArticle()") 更新する
          b-button(
            v-else
            type="is-info"
            size="is-medium"
            :loading="postSaving"
            @click="postArticle()") 保存する
          b-dropdown(
            v-if="$route.params.id"
            aria-role="list"
            :position="optionDropdown.position"
            :can-close="optionDropdown.canClose"
            :close-on-click="optionDropdown.closeOnClick")
            button.ui-icon-button.ellipsis(slot="trigger" type="button")
              b-icon.is-opacity(icon="ellipsis-v")
            template(v-if="post.release_flag && !post.link_flag")
              b-dropdown-item(@click="openArticlePage()" aria-role="listitem")
                .media
                  b-icon.media-left.is-opacity(icon="eye")
                  .media-content 表示する
              hr.dropdown-divider
            b-dropdown-item(@click="duplicateArticleConfirm()" aria-role="listitem")
              .media
                b-icon.media-left.is-opacity(icon="copy")
                .media-content 複製する
            hr.dropdown-divider
            b-dropdown-item(@click="deleteArticleConfirm()" aria-role="listitem")
              .media
                b-icon.media-left.is-danger(icon="trash-alt")
                .media-content.has-text-danger 削除する
      .postEditor_panel_body
        .postEditor_column
          .postEditor_head
            b-field._label(label="公開日")
          b-datetimepicker(
            v-model="publishedDate"
            ref="datetimepicker"
            rounded
            placeholder="Click to select..."
            icon="calender"
            :locale="dateTime.locale"
            :mobile-native="dateTime.mobileNative"
            :max-datetime="dateTime.maxDateTime"
            size="is-medium")
            template(#left)
              button(
                class="button is-primary is-medium"
                @click="publishedDate = new Date()")
                b-icon(icon="clock" size="is-small")
                span Now
            template(#right)
              button(
                class="button is-medium"
                @click="$refs.datetimepicker.toggle()")
                b-icon(icon="times" size="is-small")
                span 閉じる
        .postEditor_column(v-if="$route.params.id")
          .postEditor_head
            ._label 更新日
          p._smalltext {{ post.updated_at }}
        .postEditor_column(v-if="$route.params.id")
          .postEditor_head
            ._label 更新者
          p._smalltext {{ post.author }}
        .postEditor_column
          .postEditor_input._category
            .postEditor_head
              ._label カテゴリ
                span._required *
            b-field.is-flex
              b-select(
                v-model="post.category_id"
                name="category"
                size="is-medium"
                placeholder="カテゴリ"
                @input="resetCategory()")
                option(v-for="(category, index) in categoryList" :value="category.id") {{ category.screen_name }}
              b-select(
                v-if="subCategoryList.length > 0"
                v-model="post.sub_category_id"
                name="sabCategory"
                size="is-medium"
                placeholder="サブカテゴリ")
                option(v-for="(subCategory, index) in subCategoryList" :value="subCategory.id") {{ subCategory.screen_name }}
            b-button(
              type="is-info"
              size="is-medium"
              outlined
              icon-left="plus"
              @click="openCategoryModal()") カテゴリの追加
        template(v-if="!post.link_flag")
          .postEditor_column
            .postEditor_slug
              .postEditor_head
                label._label(for="slug") URL スラッグ
                b-tooltip.tooltip(
                  position="is-top"
                  type="is-light"
                  size="is-medium"
                  multilined)
                  button.ui-tooltip(type="button")
                    b-icon.is-opacity(icon="question-circle" size="is-small")
                  template(v-slot:content)
                    p.is-size-5.has-text-left
                      | スラッグはURLの一部として使われる名前です。<br>
                      | 【半角小文字の英数字】【-（ハイフン）】【_（アンダースコア）】を利用してください。<br><br>
                      | 未入力の場合、記事のIDがURLとして自動的に設定されます。
              template(v-if="!$route.params.id")
                .postEditor_slug_content
                  p.postEditor_slug_host._smalltext {{ publicHost }}/
                  b-input#slug(
                    type="text"
                    size="is-medium"
                    autocomplete="off"
                    maxlength=50
                    has-counter
                    v-model="post.slug"
                    @input="validateSlug")
                p.is-size-5.has-text-danger.has-text-weight-bold(v-if="slugEditForm.isError")
                  | 空白・以下の文字は、スラッグに使用できません。<br>
                  | ^ ! # $ & ' " ( ) * + , : ; = ? @ / [ ] < > % . ~
              template(v-if="$route.params.id")
                .postEditor_slug_content
                  p.postEditor_slug_url._smalltext
                    | {{ publicHost }}/
                    strong {{ post.slug }}
                b-button(
                  type="is-info"
                  size="is-medium"
                  outlined
                  icon-left="edit-alt"
                  @click="activeSlugEditModal()") スラッグの編集
        .postEditor_column
          .postEditor_thumb
            .postEditor_head
              ._label アイキャッチ画像
            .postEditor_thumb_sample(v-if="post.thumbnail")
              .postEditor_thumb_sample_image(:style="'background-image: url('+post.thumbnail+')'")
            .postEditor_thumb_buttons
              b-button(
                type="is-info"
                size="is-medium"
                outlined
                icon-left="image-v"
                @click="switchMediaModal('thumbnail')") {{ isThumbnailMessage }}
              b-button(v-if="post.thumbnail" @click="deleteThumbnail()" type="is-danger" outlined) アイキャッチ画像を削除
        .postEditor_column(v-if="!post.link_flag")
          .postEditor_input._tag
            label
              .postEditor_head
                ._label タグ
              post-tag-input(
                :old-tags="post.tags"
                @setNewTags="setNewTags")
        .postEditor_column(v-if="!post.link_flag")
          .postEditor_head
            ._label 関連記事
          .postEditor_relatedArticle
            ul.postEditor_relatedArticle_list(v-if="post.related_articles.length > 0")
              li.postEditor_relatedArticle_item(v-for="article in post.related_articles")
                .postEditor_relatedArticle_card
                  .postEditor_relatedArticle_thumb
                    .postEditor_relatedArticle_thumb_image(
                      v-if="article.thumbnail == null" :style="'background-image: url('+ defaultThumbnail +')'")
                    .postEditor_relatedArticle_thumb_image(
                      v-else :style="'background-image: url('+ article.thumbnail +')'")
                  .postEditor_relatedArticle_head
                    p.postEditor_relatedArticle_title {{ article.title }}
                    p.postEditor_relatedArticle_note(v-if="article.release_flag === false")
                      b-icon.mb-1.mr-2(icon="exclamation-circle" size="is-small")
                      | 「下書き」状態
          b-button(
            type="is-info"
            size="is-medium"
            outlined
            icon-left="list-ul"
            @click="openRelatedArticleModal()") 関連記事の設定
        .postEditor_column(v-if="!post.link_flag")
          label
            .postEditor_head
              ._label 個別CSS
            ._css
              textarea(ref="css" @keydown.prevent.tab="insertTabSpace($event)" v-model="post.css")
              b-button.btn_cssPreview(
                type="is-info"
                size="is-medium"
                outlined
                @click="applyCss") 内容に反映する

    //カテゴリ追加モーダル
    b-modal.categoryModal(:active.sync="category.isModalActive" :width="640")
      category-modal(
        :is-modal-active="category.isModalActive"
        :modal-type="category.modalType"
        :parent-category-list="categoryList"
        @setNewData="setCategoryList"
        @closeModal="closeCategoryModal")
    //スラッグ編集モーダル
    b-modal(:active.sync="slugEditForm.isModalActive" :width="640")
      .modal-card
        .modal-card-head
          header URL スラッグを変更
        .modal-card-body
          b-field(label-for="slug")
            template(v-slot:label)
              | スラッグ
              button.ml-3.ui-tooltip(type="button" @click="slugEditForm.isDescriptionOpen = !slugEditForm.isDescriptionOpen")
                b-icon.is-opacity(icon="question-circle" size="is-small")
          p.mb-5.is-size-5.has-text-left(v-if="slugEditForm.isDescriptionOpen")
            | スラッグはURLの一部として使われる名前です。<br>
            | 【半角小文字の英数字】【-（ハイフン）】【_（アンダースコア）】を利用してください。<br><br>
            | 未入力の場合、記事のIDがURLとして自動的に設定されます。
          .postEditor_slug_content
            p.postEditor_slug_host._smalltext
              | {{ publicHost }}/
            b-input#slug(
              type="text"
              size="is-medium"
              autocomplete="off"
              maxlength=50
              has-counter
              v-model="slugEditForm.input"
              @input="validateSlug")
          p.is-size-5.has-text-danger.has-text-weight-bold(v-if="slugEditForm.isError")
            | 空白・以下の文字は、スラッグに使用できません。<br>
            | ^ ! # $ & ' " ( ) * + , : ; = ? @ / [ ] < > % . ~
        .modal-card-foot
          b-button(
            type="is-info"
            size="is-medium"
            :disabled="!slugEditForm.isCompleted"
            @click="changeSlug") 変更する
    // 関連記事モーダル
    b-modal.relatedArticle_modal(
      v-model="relatedArticle.isModalActive"
      :width="1000"
      @close="validateRelatedArticleModal")
      related-article-modal(
        :is-modal-active="relatedArticle.isModalActive"
        :old-related-article-list="post.related_articles"
        :article="post"
        @closeModal="closeRelatedArticleModal"
        @passNewRelatedArticleList="passNewRelatedArticleList"
        @setRelatedArticle="setRelatedArticle")
    // 画像モーダル
    b-modal.post_media_modal(:active.sync="media.isModalActive" :width="1000")
      post-media-modal(
        :is-modal-active="media.isModalActive"
        :modal-type="media.modalType"
        @insertImageInArticle="insertImageInArticle"
        @setToThumbnail="setToThumbnail")
</template>

<script>
import PostTagInput from '@/components/PostTagInput.vue'
import CategoryModal from '@/components/CategoryModal.vue'
import PostMediaModal from '@/components/PostMediaModal.vue'
import RelatedArticleModal from '@/components/RelatedArticleModal.vue'

import cookies from 'vue-cookies'

const token = cookies.get('token')

export default {
  name: 'Post',
  head: {
    title() {
      return {
        inner: '記事の投稿・編集',
        separator: '|',
        complement: '管理画面',
      }
    }
  },
  components: {
    PostTagInput,
    CategoryModal,
    PostMediaModal,
    RelatedArticleModal
  },
  data(){
    const _maxDateTime= new Date()
    _maxDateTime.setDate(_maxDateTime.getDate())

    return {
      /* post editor's value */
      initControls: null,
      is_initialized: false,
      config: {
        charCounterCount: true,
        placeholderText: '',
        height: 450,
        zIndex: 90,
        iframe: true,
        iframeStyle: null,
        iframeStyleFiles: [
          'https://use.typekit.net/goh2cac.css'],
        key: '7MD3aA3H3A5C4D4A1xfiuG-7licbhH5ei1mA11C8D6B5B1F4C3F2I3C9==',
        language: 'ja',
        quickInsertEnabled: false,
        toolbarButtons: {
          'moreText': {
            'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'clearFormatting'],
            'buttonsVisible': 4
          },
          'moreParagraph': {
            'buttons': ['paragraphFormat', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatUL', 'formatOLSimple', 'lineHeight', 'outdent', 'indent', 'quote'],
            'buttonsVisible': 4
          },
          'moreRich': {
            'buttons': ['insertLink', 'insertVideo', 'insertFile', 'insertTable', 'insertHR'],
            'buttonsVisible': 5
          },
          'moreMisc': {
            'buttons': ['html', 'undo', 'redo', 'fullscreen', 'print', 'spellChecker', 'selectAll', 'help'],
            'align': 'right',
            'buttonsVisible': 3
          },
        },
        // font styles
        paragraphFormat: {
          N: '段落',
          H2: '見出し2',
          H3: '見出し3',
          H4: '見出し4',
        },
        lineHeights: {
          'デフォルト': '',
          '1.4': '1.4',
          '1.5': '1.5',
          '1.6': '1.6',
          '1.7': '1.7',
          '1.8': '1.8',
          '1.9': '1.9',
          '2.0': '2'
        },
        fontFamily: {
          '': 'デフォルト',
          'futura-pt, sans-serif': 'Futura',
        },
        formatULs: {
          'defaut': 'デフォルト',
        },
        // font style
        fontSizeSelection: true,
        fontSizeDefaultSelection: '1.6',
        fontSize: ['1.0', '1.1', '1.2', '1.3', '1.4', '1.5', '1.6', '1.7', '1.8', '2', '2.5', '3', '3.5', '4'],
        fontSizeUnit: 'rem',
        // inline styles
        inlineClasses: {
          'fr-class-code': 'コード',
          'fr-class-highlighted': 'ハイライト',
          'fr-class-transparency': '半透明'
        },
        // link styles
        linkEditButtons: ['linkOpen', 'linkEdit', 'linkRemove'],
        // image styles
        imageEditButtons: ['imageAlign', 'imageCaption', 'imageAlt', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '-', 'imageStyle', 'imageSize', 'imageRemove'],
        imageDefaultWidth: 0,
        // video styles
        videoInsertButtons: ['videoBack', '|', 'videoByURL', 'videoEmbed'],
        // table styles
        tableEditButtons: ['tableHeader', 'tableRemove', '|', 'tableRows', 'tableColumns', 'tableStyle', '-', 'tableCells', 'tableCellBackground', 'tableCellVerticalAlign', 'tableCellHorizontalAlign', 'tableCellStyle'],
        tableStyles: {
          'fr-alternate-rows': 'しましま',
          'fr-border-none': '枠なし'
        },
        // code mirror
        codeMirror: window.CodeMirror,
        codeMirrorOptions: {
          indentWithTabs: true,
          lineNumbers: true,
          lineWrapping: true,
          mode: 'text/html',
          tabMode: 'indent',
          tabSize: 2
        },
        /* Froala WYSIWYG HTML Editor filters the pasted content and keeps only plain text by removing all its rich formatting. */
        pastePlain: true,

        // Upload File
        fileUploadParam: 'file',
        fileUploadURL: process.env.VUE_APP_API_ENDPOINT + process.env.VUE_APP_API_BASE_PATH + this.$constants.API_PATH.FILES,
        fileUploadMethod: 'POST',
        // Set max file size to 20MB.
        fileMaxSize: 20 * 1024 * 1024,
        fileAllowedTypes: ['application/pdf'],

        requestHeaders: {
            Authorization: `Token ${token}`
        },

        events: {
          'file.error': function(error) {
            const message = document.querySelector('.fr-file-progress-bar-layer .fr-message')

            // File too text-large.
            if ( error.code == 5 ) {
              message.innerText = 'アップロードできるファイルサイズは 最大20MB です。'
            }
            // Invalid file type.
            else if ( error.code == 6 ) {
              message.innerText = 'アップロードできるファイル形式は .pdf です。'
            }
            else {
              message.innerText = 'ファイルのアップロードに失敗しました。時間を空けて、もう一度お試しください。'
            }
          }
        }
      },

      /* 外部リンク input */
      externalLinkInput: {
        isDisabled: true
      },

      /* スラッグ編集フォーム */
      slugEditForm: {
        input: null,
        isModalActive: false,
        isError: false,
        isCompleted: false,
        isDescriptionOpen: false
      },

      /* カテゴリ・サブカテゴリ */
      categoryList: [],
      subCategoryList: [],
      category: {
        isModalActive: false,
        modalType: 'add'
      },

      /* 画像 */
      media: {
        isModalActive: false,
        modalType: null
      },

      /* 関連記事 */
      relatedArticle: {
        isModalActive: false,
        canCloseModal: true,
        newList: []
      },
      defaultThumbnail: process.env.VUE_APP_PUBLIC_PATH + 'img/thumb_default.jpg',

      /* datetimepicker settings */
      dateTime: {
        locale: "ja-JP",
        mobileNative: true,
        maxDateTime: _maxDateTime
      },
      publishedDate: new Date(),
      updateDate: new Date(),

      post: {
        link: "",
        link_flag: false,
        release_flag: true,
        title: "",
        description: "",
        slug: "",
        content: "",
        thumbnail: null,
        author: null,
        tags: [],
        css: "",
        published_at: new Date(),
        related_articles: [],
        // 以下プレビュー用
        category: null,
        sub_category: null,
        // 編集時は$setで追加
        category_id: null,
        sub_category_id: null,
        related_articles_id: [],
      },
      changedContent: false, // post.contentの変更監視
      positionInContent: null, // 記事本文内で入力中の位置


      isLinkMessage: '記事を作成してください',
      isPublishMessage: '公開',
      isThumbnailMessage: 'アイキャッチ画像の設定',

      /* 保存・更新ボタンローディング */
      postSaving: false,

      /* 画面ローディング設定 */
      isLoading: false,
      isFullPage: false,

      /* 3点リーダー */
      optionDropdown: {
        position: 'is-bottom-left',
        canClose: true,
        closeOnClick: true
      },

      publicHost: process.env.VUE_APP_PUBLIC_HOST,

      datetimeID: null, // 新規投稿の場合に利用
      previewID: 'new', // 保存済み記事編集の場合に利用
    }
  },
  created() {
    this.getCategoryList()

    this.$nextTick(function(){
      if (this.$route.params.id) {
        this.getArticle()
      } else {
        const current_unixtime = Date.now()
        this.datetimeID = 'preview-' + current_unixtime
      }
    })

    window.addEventListener('beforeunload', this.removeUnderEdit)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.removeUnderEdit)
  },
  watch: {
    '$route': function() {
      if (this.$route.params.id) {
        this.getArticle()
      } else { // post後に、ページ戻る場合の対策
        this.post = {
          link: "",
          link_flag: false,
          release_flag: true,
          title: "",
          description: "",
          slug: "",
          content: "",
          thumbnail: null,
          author: null,
          tags: [],
          css: "",
          published_at: new Date(),
          related_articles: [],
          // 以下プレビュー用
          category: null,
          sub_category: null,
          // 編集時は$setで追加
          category_id: null,
          sub_category_id: null,
          related_articles_id: []
        }
        this.getCategoryList()
        this.$nextTick(function() {
          this.changedContent = false

          const current_unixtime = Date.now()
          this.datetimeID = 'preview-' + current_unixtime
        })
      }
    },
    'post.link_flag': function(v){
      this.isLinkMessage = v ? 'リンク先を指定してください' : '記事を作成してください'
      if( v ) {
        this.destroy()
      } else {
        this.$nextTick(function() {
          this.initControls.initialize()
        } )
      }
    },
    'post.link': function(v){
      if( v !== null && ( v.startsWith('https://') || v.startsWith('http://') ) ) {
        this.externalLinkInput.isDisabled = false
      } else {
        this.externalLinkInput.isDisabled = true
      }
    },
    'post.release_flag': function(v){
      this.isPublishMessage = v ? '公開' : '下書き'
    },
    'post.thumbnail': function(v){
      this.isThumbnailMessage = v ? '画像を変更' : 'アイキャッチ画像の設定'
    },
    'publishedDate': function(date) {
      this.post.published_at = date.getFullYear() + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2)+ '/' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2)
    },
    'post.content': function(){
      this.changedContent = true
    },
    'changedContent': function(bool){
      if(bool) {
        this.$store.dispatch('setCanLogout', false)
      } else {
        this.$store.dispatch('setCanLogout', true)
      }
    },
    'relatedArticle.isModalActive':function() {
      if( this.relatedArticle.canCloseModal === false ) this.relatedArticle.isModalActive = true
    }
  },
  beforeRouteLeave (to, from, next) {
    const loggedIn = this.$cookies.isKey('user_name') && this.$cookies.isKey('token')

    if ( loggedIn && this.changedContent === true && this.$store.state.clickedLogout === false ) {
      this.$buefy.dialog.confirm({
        title: 'このページを離れますか？',
        message: '保存・更新をせずにページを離れると、編集した内容は保存されません。',
        confirmText: 'このページを離れる',
        cancelText: 'キャンセル',
        type: 'is-danger',
        size: 'is-medium',
        hasIcon: true,
        icon: 'exclamation-circle',
        onConfirm: () => {
          this.removeUnderEdit()
          next()
        },
        onCancel: () => {
          next(false)
        }
      })
    } else {
      next()
    }
  },
  destroyed() {
    this.$store.dispatch('setCanLogout', true)
  },
  methods: {
    removeUnderEdit() {
      if( this.datetimeID === null ) { // 編集の場合
        localStorage.removeItem('post-' + this.previewID)
      } else { // 新規投稿の場合
        localStorage.removeItem('post-' + this.datetimeID)
      }
    },
    activeSlugEditModal(){
      this.slugEditForm.input = this.post.slug
      this.slugEditForm.isModalActive = true
      this.slugEditForm.isError = false
      this.slugEditForm.isCompleted = true
    },
    changeSlug(){
      if(this.slugEditForm.input.length > 0){
        this.post.slug = this.slugEditForm.input
      } else {
        this.post.slug = this.post.id
      }
      this.slugEditForm.isModalActive = false
    },
    openArticlePage(){
      window.open(process.env.VUE_APP_PUBLIC_HOST + '/' + this.post.slug, '_blank')
    },
    duplicateArticleConfirm(){
      this.$buefy.dialog.confirm({
        title: '記事を複製しますか？',
        message: '下書きの状態で記事が複製されます。',
        confirmText: '記事を複製する',
        cancelText: 'キャンセル',
        type: 'is-info',
        size: 'is-medium',
        onConfirm: () => {
          this.duplicateArticle()
        }
      })
    },
    deleteArticleConfirm(){
      this.$buefy.dialog.confirm({
        title: '記事を削除しますか？',
        message: '削除した記事は復元できません。<br>公開せずに保存しておく場合は、下書きに設定して保存を押してください。',
        confirmText: '記事を削除する',
        cancelText: 'キャンセル',
        type: 'is-danger',
        size: 'is-medium',
        hasIcon: true,
        icon: 'exclamation-circle',
        onConfirm: () => {
          this.changedContent = false
          this.deleteArticle()
        }
      })
    },
    validateSlug(val){
      const unusableCharacters = val.match(/[\^!#$&'"()*+,:;=?@/[\]<>%.~\\\s]/)
      this.slugEditForm.isError = ( unusableCharacters != null ) ? true : false
      this.slugEditForm.isCompleted = ( !this.slugEditForm.isError ) ? true : false
    },
    applyCss(){
      this.config.iframeStyle = this.post.css
      this.destroy()
      this.initialize(this.initControls)
    },
    initialize: function(initControls) {
      if( this.is_initialized ) return
      this.initControls = initControls
      this.initControls.initialize()
      this.is_initialized = true
      this.setUniqueSetting()
    },
    destroy: function(){
      this.initControls.destroy()
      this.is_initialized = false
    },
    setUniqueSetting: function() {
      const froalaEditor = document.querySelector('#froala-editor')

      if( !froalaEditor ) return

      const froalaIframe = froalaEditor.querySelector('iframe')
      const froalaIframeBody = froalaIframe.contentWindow.document.body
      const froalaIframeHead = froalaIframe.contentWindow.document.head
      froalaIframeBody.classList.add('article_body')

      // iframeStyle(<style></style>)より前に読み込みたいため、ここで設定
      const linkTag = document.createElement('link')
      linkTag.rel = 'stylesheet'
      linkTag.href = process.env.VUE_APP_PUBLIC_PATH + 'css/postEditor.css'
      froalaIframeHead.appendChild(linkTag)
    },
    insertTabSpace(event){
      event.preventDefault()
      let obj = this.$refs.css
      let cursorPosition = obj.selectionStart
      let cursorLeft   = obj.value.substr( 0, cursorPosition )
      let cursorRight  = obj.value.substr( cursorPosition, obj.value.length )
      obj.value = cursorLeft+"\t"+cursorRight
      obj.selectionEnd = cursorPosition+1
    },
    resetCategory(){
      const _categoryIndex = this.categoryList.findIndex(category => category.id == this.post.category_id)
      this.subCategoryList = this.categoryList[_categoryIndex].sub_category
      if( this.subCategoryList.length > 0 ) {
        this.post.sub_category_id = this.subCategoryList[0].id
      } else {
        this.post.sub_category_id = ''
      }
    },
    openCategoryModal(){
      this.category.isModalActive = true
    },
    closeCategoryModal(){
      this.category.isModalActive = false
    },
    switchMediaModal(type) {
      this.media.isModalActive = !this.media.isModalActive

      this.media.modalType = type
    },
    deleteThumbnail() {
      this.post.thumbnail = null
    },
    insertImageInArticle(url){
      this.initControls.getEditor().image.insert(url)
      this.media.isModalActive = false
    },
    setToThumbnail(url) {
      this.post.thumbnail = url
      this.media.isModalActive = false
    },
    openRelatedArticleModal() {
      this.relatedArticle.isModalActive = true
    },
    closeRelatedArticleModal() {
      this.relatedArticle.canCloseModal = true
      this.relatedArticle.isModalActive = false
    },
    validateRelatedArticleModal() {
      this.relatedArticle.canCloseModal = false
      if( JSON.stringify(this.post.related_articles) !== JSON.stringify(this.relatedArticle.newList) ) {
        this.$buefy.dialog.confirm({
          title: '設定に反映しますか？',
          message: '関連記事の追加・変更を設定に反映する場合は、<br>「設定に反映する」ボタンを押してください。',
          confirmText: '設定に反映する',
          cancelText: '反映せずに閉じる',
          type: 'is-info',
          size: 'is-medium',
          hasIcon: false,
          onConfirm: () => {
            this.setRelatedArticle()
          },
          onCancel: () => {
            this.closeRelatedArticleModal()
          }
        })
      } else {
        this.closeRelatedArticleModal()
      }
    },
    passNewRelatedArticleList(relatedArticleList) {
      this.relatedArticle.newList = relatedArticleList
    },
    setRelatedArticle() {
      this.post.related_articles = this.relatedArticle.newList
      this.post.related_articles_id = this.post.related_articles.map(article => article.id)

      this.closeRelatedArticleModal()
    },
    setNewTags(newTags) {
      this.post.tags = newTags
    },
    openLinkPage() {
      window.open(this.post.link, '_blank')
    },
    previewArticle(){
      let _id = ''
      if( this.datetimeID === null ) { // 編集の場合
        _id = this.previewID
      } else { // 新規投稿の場合
        _id = this.datetimeID
      }

      let _categoryIndex = this.categoryList.findIndex(category => category.id === this.post.category_id)
      this.post.category = this.categoryList[_categoryIndex]

      if( this.categoryList[_categoryIndex].sub_category.length > 0) {
        let _subCategory = this.categoryList[_categoryIndex].sub_category.find(subCategory => subCategory.id === this.post.sub_category_id)
        if( _subCategory ) {
          this.post.sub_category = _subCategory
        }
      }

      const routeData = this.$router.resolve({ name: 'preview', query: { id: _id }, params: { post: this.post }})
      localStorage.setItem( 'post-' + _id, JSON.stringify(this.post) )
      window.open( routeData.href, _id )
    },
    async getCategoryList(type, categoryId, subCategoryId) {
      try {
        const data_obj = {
          sort: 2
        }
        const res = await this.$axios.get(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.CATEGORIES,
          { params:data_obj }
        )
        const r = res.data
        if( r.status == 1 ){
          const data = r.data
          this.categoryList = data

          if( this.categoryList.length > 0 ) {

            if( type === 'add' ) { // カテゴリを追加した場合
              const _category_index = this.categoryList.findIndex(category => category.id == categoryId)
              if( this.categoryList[_category_index] ) this.subCategoryList = this.categoryList[_category_index].sub_category

              this.$set(this.post, 'category_id', categoryId)
              this.$set(this.post, 'sub_category_id', subCategoryId)
            } else if ( !this.$route.params.id ) { // 新規投稿の場合、カテゴリ・サブカテゴリの初期値設定
              const first_category_id = this.categoryList[0].id
              this.$set(this.post, 'category_id', first_category_id)

              if(this.categoryList[0]) this.subCategoryList = this.categoryList[0].sub_category

              let first_sub_category_id
              if (this.subCategoryList.length > 0) {
                first_sub_category_id = this.subCategoryList[0].id
              } else {
                first_sub_category_id = ''
              }
              this.$set(this.post, 'sub_category_id', first_sub_category_id)
            }

          }
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, 'カテゴリの取得に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
    setCategoryList(categoryId, subCategoryId) {
      // カテゴリ追加時のカテゴリ・サブカテゴリ設定
      this.getCategoryList('add', categoryId, subCategoryId)
    },
    async getArticle() {
      try {
        this.isLoading = true
        const id = this.$route.params.id
        const res = await this.$axios.get(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.ARTICLES_.replace(':id', id)
        )

        const r = res.data

        if( r.status == 1 ){
          const data = r.data
          this.post = data

          this.post.tags = data.tags.map(item => item.name)

          // 外部リンクで保存 → 通常記事に戻す時の対策
          if(this.post.slug == null) {
            this.post.slug = this.post.id
          }

          const postDate = data.published_at
          this.publishedDate = new Date(postDate)

          this.previewID = 'preview-' + this.post.id

          this.$nextTick(function() {
            this.changedContent = false

            if( this.post.link_flag === false ) {
              this.applyCss()
            }

            // カテゴリ・サブカテゴリ設定
            const _category_id = data.category.id
            this.$set(this.post, 'category_id', _category_id)

            const _category_index = this.categoryList.findIndex(category => category.id == _category_id)
            if( this.categoryList[_category_index] ) this.subCategoryList = this.categoryList[_category_index].sub_category
            const _sub_category = data.sub_category
            let _sub_category_id
            if( _sub_category ) {
              _sub_category_id = data.sub_category.id
            } else {
              _sub_category_id = ''
            }
            this.$set(this.post, 'sub_category_id', _sub_category_id)

            // 関連記事ID設定
            this.post.related_articles_id = this.post.related_articles.map(article => article.id)
          })
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '記事の取得に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.isLoading = false
      }
    },
    async postArticle() {
      try {
        this.postSaving = true

        const data_obj = {
          article: {
            published_at: this.post.published_at,
            link_flag: this.post.link_flag,
            release_flag: this.post.release_flag,
            title: this.post.title,
            slug: this.post.slug,
            thumbnail: this.post.thumbnail,

            category_id: this.post.category_id,
            sub_category_id: this.post.sub_category_id,

            author: this.$cookies.get('user_name'),
            tags: this.post.tags,
          }
        }

        if(this.post.link_flag === true){
          data_obj.article.link = this.post.link
        } else {
          data_obj.article.content = this.post.content
          data_obj.article.description = this.post.description
          data_obj.article.css = this.post.css
          data_obj.article.related_articles_id = this.post.related_articles_id
        }

        const data_json = JSON.stringify(data_obj)
        const config = { headers: {"Content-Type": "application/json"} }

        const res = await this.$axios.post(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.ARTICLES,
          data_json,
          config
        )
        const r = res.data
        if( r.status == 1 ){
          this.$common.createSuccessMessage('新しい記事を投稿しました')
          const data = r.data
          this.changedContent = false
          this.$router.push({ name: 'post', params: { id: data.id } })
        }else{
          let errorMessage = new Array()
          for(let i =0;i < r.errors.length; i++){ // updateArticleと内容合わせる
            if(r.errors[i].status == 403) {
              this.$store.dispatch('promptToLogin')
              return
            } else if (r.errors[i].status == 59){
              errorMessage.push('タイトルを入力してください。')
            } else if(r.errors[i].status == 60){
              errorMessage.push('タイトルは100字以内で入力してください。')
            } else if(r.errors[i].status == 61){
              errorMessage.push('内容を30000字以内（目安）で入力してください。')
            } else if(r.errors[i].status == 63){
              errorMessage.push('概要を150字以内で入力してください。')
            } else if(r.errors[i].status == 66){
              errorMessage.push('このURLスラッグはすでに存在します。')
            } else if(r.errors[i].status == 67){
              errorMessage.push('URLスラッグは50字以内で入力してください。')
            } else if(r.errors[i].status == 68){
              errorMessage.push('URLスラッグに使用できない文字が入力されています。')
            } else if(r.errors[i].status == 69){
              errorMessage.push('外部リンクのリンク先を入力してください。')
            } else if(r.errors[i].status == 70){
              errorMessage.push('カテゴリを選択してください。')
            } else {
              errorMessage.push('記事の投稿に失敗しました。時間を空けて、もう一度お試しください。')
            }
          }
          errorMessage = errorMessage.join('<br>')
          this.$common.createErrorMessage(r.errors, errorMessage)
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.postSaving = false
      }
    },
    async updateArticle() {
      try {
        this.postSaving = true

        const data_obj = {
          article: {
            published_at: this.post.published_at,
            link_flag: this.post.link_flag,
            release_flag: this.post.release_flag,
            title: this.post.title,
            slug: this.post.slug,
            thumbnail: this.post.thumbnail,

            category_id: this.post.category_id,
            sub_category_id: this.post.sub_category_id,

            author: this.$cookies.get('user_name'),
            tags: this.post.tags,
          }
        }

        if(this.post.link_flag === true){
          data_obj.article.link = this.post.link
        } else {
          data_obj.article.content = this.post.content
          data_obj.article.description = this.post.description
          data_obj.article.css = this.post.css
          data_obj.article.related_articles_id = this.post.related_articles_id
        }

        const data_json = JSON.stringify(data_obj)
        const config = { headers: {"Content-Type": "application/json"} }

        const res = await this.$axios.put(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.ARTICLES_.replace(':id', this.post.id),
          data_json,
          config
        )

        const r = res.data

        if( r.status == 1 ){
          this.$common.createSuccessMessage('記事を更新しました')
          this.getArticle()
        }else{
          let errorMessage = new Array()
          for(let i =0;i < r.errors.length; i++){
            if(r.errors[i].status == 403) {
              this.$store.dispatch('promptToLogin')
              return
            } else if (r.errors[i].status == 59){
              errorMessage.push('タイトルを入力してください。')
            } else if(r.errors[i].status == 60){
              errorMessage.push('タイトルは100字以内で入力してください。')
            } else if(r.errors[i].status == 61){
              errorMessage.push('内容を30000字以内（目安）で入力してください。')
            } else if(r.errors[i].status == 63){
              errorMessage.push('概要を150字以内で入力してください。')
            } else if(r.errors[i].status == 66){
              errorMessage.push('このURLスラッグはすでに存在します。')
            } else if(r.errors[i].status == 67){
              errorMessage.push('URLスラッグは50字以内で入力してください。')
            } else if(r.errors[i].status == 68){
              errorMessage.push('URLスラッグに使用できない文字が入力されています。')
            } else if(r.errors[i].status == 69){
              errorMessage.push('外部リンクのリンク先を入力してください。')
            } else if(r.errors[i].status == 70){
              errorMessage.push('カテゴリを選択してください。')
            } else if(r.errors[i].status == 80){
              errorMessage.push('関連記事には、当記事以外を選択してください。')
            } else {
              errorMessage.push('記事の更新に失敗しました。時間を空けて、もう一度お試しください。')
            }
          }
          errorMessage = errorMessage.join('<br>')
          this.$common.createErrorMessage(r.errors, errorMessage)
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.postSaving = false
      }
    },
    async duplicateArticle() {
      try {
        const res = await this.$axios.put(
          process.env.VUE_APP_API_ENDPOINT +
            process.env.VUE_APP_API_BASE_PATH +
            this.$constants.API_PATH.ARTICLES_DUPLICATE.replace(':id', this.post.id),
        )
        const r = res.data
        if (r.status == 1) {
          this.$common.createSuccessMessage('記事を複製しました。')
          this.$router.push({ name: 'article' })
        } else {
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '記事の複製に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
    async deleteArticle() {
      try {
        const res = await this.$axios.delete(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.ARTICLES_.replace(':id', this.post.id)
        )
        const r = res.data
        if( r.status == 1 ){
          this.$common.createSuccessMessage('記事を削除しました')
          this.$router.push({ name: 'article' })
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '記事の削除に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
  }
}
</script>

<style>
/* froalaバグ対応 */
.fr-popup.fr-active.fr-hidden {
  opacity: 1;
}

</style>